import { ADMIN_BREADCRUMB } from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = {
    locations: [],
    set: false
};

function reducer(state = initialState, action) {
    switch (action.type) {
        case ADMIN_BREADCRUMB.SET:
            return { ...state, locations: action.locations, set: true };
        case ADMIN_BREADCRUMB.REFRESH:
            return { ...state, set: false };
        case LOCATION_CHANGE:
            return initialState;
        default:
            return state;
    }
}

export default reducer;
